import React from "react";
import { MdMap, MdDepartureBoard, MdRoom } from "react-icons/md";

export const Sidebar = [
  {
    title: "Mapa",
    path: "/",
    icon: <MdMap />,
    cName: "nav-text",
  },
  {
    title: "Linhas",
    path: "/linha",
    icon: <MdDepartureBoard />,
    cName: "nav-text",
  },
  {
    title: "Endereço",
    path: "/endereco",
    icon: <MdRoom />,
    cName: "nav-text",
  },
];
